
import React from 'react';
import { FileText } from 'lucide-react';

const MediaContact = () => {
  return (
    <section className="mb-16">
      <h2 className="section-title-left mb-6">Media Contact</h2>
      <div className="bg-neutral-cream p-8 rounded-md shadow-sm">
        <h3 className="font-playfair text-xl font-bold mb-2">Daniel Rimada</h3>
        <p className="mb-2 text-text/80">Co-Founder, Cats About Town Walking Tours</p>
        <a 
          href="mailto:catsabouttowntour@gmail.com" 
          className="text-accent hover:text-accent/80 transition-colors flex items-center"
        >
          <FileText size={16} className="mr-1" />
          catsabouttowntour@gmail.com
        </a>
      </div>
    </section>
  );
};

export default MediaContact;
